<template>
  <!-- 新品推荐页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar
        title="新品速递"
        :placeholder="true"
        left-arrow
        @click-left="toIndex"
      />
    </div>
    <div class="center">
      <div class="productList">
        <ul>
          <li
            v-for="item in this.activityProduct"
            @click="getProductInfo(item.goods_id)"
            :key="item.id"
          >
            <div class="productImg">
              <img v-lazy="item.image_url" alt="" />
            </div>
            <div class="proName">
              <p class="p1">{{ item.goods_name }}</p>
              <p class="p2" v-html="item.goods_desc"></p>
              <div class="foot">
                <span class="money"
                  >￥{{ Number(item.outer_goods_price).toFixed(2) }}</span
                >

                <van-button
                class="btn"
                style="padding:0 0.2667rem"
                  size="mini"
                  >立即抢购</van-button
                >
              </div>

              <!-- <span class="satisfied">满意度100%</span> -->
            </div>
          </li>
        </ul>
      </div>
      <!-- <van-checkbox
        v-for="item in activityProduct"
        :key="item.id"
        label-disabled
      >
        <van-card
          @click="getProductInfo(item.id)"
          :price="item.outer_goods_price.toFixed(2)"
          :title="item.name"
          :thumb="item.image_url"
        >
          <div slot="tags">
            <van-tag><span v-html="item.content"></span></van-tag>
            <van-button
              color="orange"
              size="small"
              @click="getProductInfo(item.id)"
              >立即购买</van-button
            >
          </div>
        </van-card>
      </van-checkbox> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value1: 1,
      value2: 2,
      activityProduct: {},
    };
  },
  created() {
    this.getActivityClass();
  },
  methods: {
    // 获取新品推荐商品
    async getActivityClass() {
      await this.$post({
        url: "/owsProductInfo/findActivityProducts",
        method: "post",
        params: {
          // userId: sessionStorage.getItem("EXCLUSIVE"),
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.activityProduct = res.data.code;
            sessionStorage.setItem("P_ID", this.activityProduct.id);
          }
        })
        .catch((err) => {});
    },
    // 获取全部活动商品
    // async getActivityClass() {
    //   await this.$post({
    //     url: "/owsProductInfo/findActivityProducts",
    //     method: "post",
    //   })
    //     .then((res) => {
    //       if (res.retCode == 200) {
    //         this.activityProduct = res.data.code;
    //       }
    //     })
    //     .catch((err) => {});
    // },
    // 点击查看
    getProductInfo(id) {
      sessionStorage.setItem("P_ID", id);
      this.$router.push({ path: "/toShopping" });
    },
    toIndex() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  position: relative;
  // background: rgba(245, 245, 245, 1);
  overflow: hidden;
  .header {
    // width: 100%;
    // position: fixed;
    // top: 0;
    // left: 0;
    // z-index: 1;
    background-color: #fff;
    .van-nav-bar {
      background-color: #40000000;
      /deep/.van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #030303;
          font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
  }
  .productList {
    padding: 0 0.4rem;
    margin: 0 auto;
    margin: 0.27rem 0;
    overflow: hidden;
    ul {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 4.466667rem;
        height: auto;
        margin-bottom: 0.266667rem;
        padding-bottom: 0.266667rem;
        border-radius: 0.133333rem;
        overflow: hidden;
        background: rgba(255, 255, 255, 1);
        &:nth-of-type(even) {
          margin-left: 0.1rem;
        }
        .productImg {
          text-align: center;
          box-sizing: border-box;
          overflow: hidden;
          background-color: #F6F5F8;
          img {
            display: block;
            width: 4.4533rem;
            overflow: hidden;
          }
        }
        .proName {
          margin: 0 0.27rem;
          margin-top: 0.15rem;
          .foot {
            margin-top: 0.16rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .btn{
              border-radius: 0.373333rem;
              color: #FFFFFF;
              background-color: #F74B2E;
              border: 0 ;
            }
          }
          .p1 {
            font-size: 0.373333rem;
            color: #333333;
            font-weight: 600;
            white-space: nowrap; /*文字不换行*/
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .p2 {
            height: 0.426667rem;
            font-size: 0.266667rem;
            font-weight: 400;
            color: #666666;
            white-space: nowrap; /*文字不换行*/
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .money {
            display: block;
            // margin-top: 0.16rem;
            color: #f5492c;
            font-size: 0.373333rem;
            font-weight: 600;
          }
          .satisfied {
            float: right;
            color: #999999;
            font-size: 0.21rem;
            line-height: 0.8rem;
          }
        }
      }
    }
  }
  // .center {
  //   height: 100%;
  //   margin: 1rem 0.27rem 0 0.27rem;
  //   background-color: #1f000000;
  //   padding-top: 0.83rem;
  //   .van-checkbox {
  //     background-color: #ffffff;
  //     border-radius: 0.21rem;
  //     margin-bottom: 0.27rem;
  //     /deep/.van-checkbox__icon.van-checkbox__icon--round {
  //       display: none;
  //     }
  //   }
  //   .van-card {
  //     width: 22.1875rem;
  //     height: 2.75rem;
  //     margin-top: 0.5rem;
  //     float: right;
  //     background-color: #ffffff;
  //     border-radius: 8%;
  //     .van-card__content {
  //       margin-left: 0.5rem;
  //       .van-tag.van-tag--plain.van-tag--default.van-hairline--surround {
  //         font-size: 0rem;
  //         .van-tag.van-tag--plain.van-tag--danger.van-hairline--surround {
  //           color: #ccc;
  //         }
  //       }
  //       .van-button {
  //         margin-left: 3.5rem;
  //         display: block;
  //         border-radius: 0.11rem;
  //       }
  //     }
  //     .van-tag {
  //       padding: 0.2em 0.3em;
  //     }
  //     .van-tag--default {
  //       background-color: #fff;
  //     }
  //     .van-tag.van-tag--default {
  //       color: #ccc;
  //       span {
  //         width: 3.5rem;
  //         display: -webkit-box;
  //         -webkit-box-orient: vertical;
  //         -webkit-line-clamp: 1;
  //         overflow: hidden;
  //       }
  //     }
  //     .van-card__price {
  //       color: red;
  //     }
  //   }
  // }
}
</style>
